// import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

class AuthService {
    
    login(login_form){
        return login_form.post(`${API_URL}/admins/authenticate`);
    }
}

export default new AuthService();
